

















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { secondsToHmsNumber } from '../../utils/utils'
import ProgressRotate from './ProgressRotate.vue'
import { format } from 'date-fns'

@Component({
  components: {
    ProgressRotate
  }
})
export default class ExamTimer extends Vue {
  @Prop({required: true})
  time: number

  @Prop({required: true})
  timeLimit: number

  @Prop()
  startTime: string

  timer: number | null = null
  remainingTime: number = 0
  endTimestamp: number = 0

  secondsToHmsNumber = secondsToHmsNumber

  @Watch('time', { immediate: true })
  onTimeChange(newTime: number) {
    this.remainingTime = newTime;
    
    if (this.startTime) {
      const startTimestamp = new Date(this.startTime).getTime();
      this.endTimestamp = startTimestamp + (this.timeLimit * 60 * 1000);
    } else {
      this.endTimestamp = Date.now() + (this.remainingTime * 1000);
    }
    
    this.startTimer();
  }

  mounted() {
    this.startTimer();
    
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  beforeDestroy() {
    this.stopTimer();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopTimer();
    } else {
      this.updateRemainingTime();
      this.startTimer();
    }
  }

  startTimer() {
    this.stopTimer();
    this.timer = window.setInterval(() => {
      this.updateRemainingTime();
    }, 1000);
  }

  stopTimer() {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  updateRemainingTime() {
    const now = Date.now();
    const remaining = Math.max(0, Math.floor((this.endTimestamp - now) / 1000));
    
    this.remainingTime = remaining;
    
    if (this.remainingTime <= 0) {
      this.stopTimer();
      this.$emit('time-up');
    }
  }

  get endTime() {
    const endTimeMs = new Date(this.startTime).getTime() + this.timeLimit * 60 * 1000;
    return format(new Date(endTimeMs), 'HH:mm:ss');
  }

  formatDate(time: string | number) {
    if (!time) return '';
    return format(new Date(time), 'HH:mm:ss');
  }
}
